<div class="header" *ngIf="translationLoaded">
  <qai-inner-wrap class="header_inner">
  <div *ngIf="weightageCalculation; else noSkillWeight">
    <qai-score
      *ngIf="
        overallScoreWithOneSection === 'MESSAGE_ADHERENCE';
        else regularCard
      "
      [direction]="'column'"
      [size]="'medium'"
      [attr.data-testId]="'messageAdherenceScoreAverage'"
      [kind]="
        scoreCriteria === 0
          ? 'none'
          : weightAverage?.average! >= scoreCriteria
          ? 'pass'
          : 'fail'
      "
      [value]="weightAverage?.average + ''"
      [max]="'5'"
      [label]="'results.OUT_OF' | transloco"
      [border]="true"
    >
      <div
        qai-card-title
        qaiSlot="title"
        data-testId="messageAdherenceScoreTitle"
      >
        {{'results.MESSAGE_ADHERENCE' | transloco}}
      </div>

      <button
        qai-link
        qaiSlot="link"
        (click)="dialog.showModal()"
        data-testId="trackMessageAdherenceCalculations"
      >
        {{'results.SCORE_CALCULATION_QUESTION' | transloco}}
      </button>
    </qai-score>

    <dialog
      #dialog
      qai-dialog
      [heading]="'results.SCORE_CALCULATION_TITLE' | transloco"
      [attr.data-testId]="'adherenceCalculationDialog'"
    >
      {{'results.SINGLE_SCORE_EXPLANATION' | transloco}}
    </dialog>

    <ng-template #regularCard>
      <qai-score
        [description]="weightAverage?.weight + ('results.OVERALL_SCORE_PERCENT' | transloco)"
        [value]="(weightAverage?.average | number : '1.1-2') ?? '0'"
        [max]="'5'"
        [label]="'results.OUT_OF' | transloco"
        [kind]="
          scoreCriteria === 0
            ? 'none'
            : weightAverage?.average! >= scoreCriteria
            ? 'pass'
            : 'fail'
        "
        [size]="'medium'"
        [border]="true"
        [direction]="'row'"
        [attr.data-testId]="'messageAdherenceScoreAverage'"
        [style.background-color]="'white'"
      >
        <div
          qai-card-title
          qaiSlot="title"
          data-testId="messageAdherenceScoreTitle"
        >
          {{'results.SECTION_SCORE' | transloco}}
        </div>
      </qai-score>
    </ng-template>
  </div>
  <ng-template #noSkillWeight>
    <div class="content">
      <h2>{{'results.ELEVATE_MESSAGE_ADHERENCE_TITLE' | transloco}}</h2>
      <p>
        {{'results.MESSAGE_ADHERENCE_NOTE' | transloco}}
      </p>
    </div>
  </ng-template>

  <div *ngIf="weightageCalculation" class="facts">
    {{ isMessageAdherenceV2 ? dynamicTextMessageAdherenceV2() : dynamicText() }}
  </div>

  <div class="button-wrapper">
    <button
      qai-button
      [kind]="'primary'"
      [size]="'large'"
      id="btn-practice"
      class="button-container"
      data-testId="practiceAgain"
      (click)="practiceAgain($event)"
      *ngIf="
        (practiceType !== 'CERTIFICATION' ||
        (remainingAttempts && remainingAttempts > 0)) &&
        assignmentStatus?.toLowerCase() !== AppConstants.CLOSED_ASSIGNMENT_STATUS
      "
      [disabled]="isMaxAttemptsReached"
      [matTooltip]="isMaxAttemptsReached ? ('results.MAX_ATTEMPTS_REACHED' | transloco) : ''"
      matTooltipClass="tooltip-dark"
    >
      {{ getButtonText() }}
    </button>
  </div>
  </qai-inner-wrap>
</div>

<qai-inner-wrap class="body" *ngIf="translationLoaded">
  <div class="content">
    <div
      class="call-feedback-content"
      *ngIf="overallScoreWithOneSection === 'MESSAGE_ADHERENCE'"
    >
      <div class="call-feedback-header">
        <h2 data-testId="callFeedbackTitle">{{'results.CALL_FEEDBACK' | transloco}}</h2>
      </div>

      <qai-item-grid
        gap="24px"
        minItemWidth="280px"
        repeatCount="auto-fit"
        style="margin-bottom: 20px; margin-top: 20px"
      >
        <qai-result-card
          [title]="scoreOverall?.Strengths?.title || ('results.STRENGTHS'| transloco)"
          *ngIf="scoreOverall?.Strengths?.feedback"
          [attr.data-testId]="'strengthsFeedbackCard'"
        >
          <qai-glyph kind="person" qaiSlot="icon" />
          <ul *ngIf="scoreOverall?.Strengths">
            <li
              *ngFor="
                let strengths of scoreOverall?.Strengths?.feedback;
                let i = index
              "
              [attr.data-testid]="'strength-' + i"
            >
              <ng-container *ngIf="strengths | extractBold as parsed">
                <b>{{ parsed.boldText }}</b>
                {{ parsed.restText }}
              </ng-container>
            </li>
          </ul>
        </qai-result-card>

        <qai-result-card
          [title]="scoreOverall?.Opportunities?.title || ('results.OPPORTUNITIES'| transloco)"
          [attr.data-testId]="'opportunitiesFeedbackCard'"
        >
          <qai-glyph kind="mountains" qaiSlot="icon" />
          <ul *ngIf="scoreOverall?.Opportunities">
            <li
              *ngFor="
                let opportunities of scoreOverall?.Opportunities?.feedback;
                let i = index
              "
              [attr.data-testid]="'opportunities-' + i"
            >
              <ng-container *ngIf="opportunities | extractBold as parsed">
                <b>{{ parsed.boldText }}</b>
                {{ parsed.restText }}
              </ng-container>
            </li>
          </ul>
        </qai-result-card>
      </qai-item-grid>
    </div>

    <ng-container *ngIf="!isMessageAdherenceV2">
      <div
        class="skill-container"
        *ngFor="let objective of messageAdherences; let i = index"
        id="{{ 'target-' + i }}"
        [attr.data-testid]="'messageAdherence-' + i"
      >
        <div class="skill-header">
          <div class="title" [attr.data-testid]="'messageAdherenceTitle-' + i">
            {{ objective.title }}
          </div>
          <div class="badge" [attr.data-testid]="'messageAdherenceScore-' + i">
            {{ objective.score === 1
            ? ('results.NO_CREDIT' | transloco)
            : objective.score === 2
            ? ('results.PARTIAL_CREDIT' | transloco)
            : objective.score === 3
            ? ('results.FULL_CREDIT' | transloco)
            : '' }}          
          </div>
        </div>
        <div class="feedback-container">
          <div class="feedback-body">
            <p
              class="feedback-description"
              [attr.data-testid]="'messageAdherenceFeedback-' + i"
            >
              {{ objective.message }}
            </p>
          </div>
        </div>
        <div>
          <qai-item-grid
            gap="24px"
            minItemWidth="280px"
            repeatCount="auto-fit"
            style="margin-bottom: 20px"
          >
            <qai-result-card
              *ngIf="objective.positive"
              [title]= "'results.WHAT_YOU_DID_WELL' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-positives'"
            >
              <ul>
                <li [attr.data-testid]="'messageAdherence-' + i + '-positive'">
                  {{ objective.positive }}
                </li>
              </ul>
            </qai-result-card>
            <qai-result-card
              *ngIf="!objective.positive && objective.negative"
              [title]= "'results.WHAT_YOU_DID_WELL' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-missed-points'"
            >
              <ul>
                <li>
                  {{'results.MISSED_ALL_KEY_POINTS' | transloco}}
                </li>
              </ul>
            </qai-result-card>
            <qai-result-card
              *ngIf="objective.negative"
              [title]= "'results.WHAT_TO_IMPROVE' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-negatives'"
            >
              <ul>
                <li [attr.data-testid]="'messageAdherence-' + i + '-negative'">
                  {{ objective.negative }}
                </li>
              </ul>
            </qai-result-card>
            <qai-result-card
              *ngIf="objective.positive && !objective.negative"
              [title]= "'results.WHAT_TO_IMPROVE' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-perfect-score'"
            >
              <ul>
                <li>
                  {{'results.PERFECT_SCORE_MESSAGE' | transloco}}
                </li>
              </ul>
            </qai-result-card>
          </qai-item-grid>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isMessageAdherenceV2">
      <div
        class="message-adherence-container"
        *ngFor="let section of messageAdherencesV2; let i = index"
        id="{{ 'target-' + i }}"
        [attr.data-testid]="'messageAdherence-' + i"
      >
        <div class="message-adherence-header">
          <div class="title" [attr.data-testid]="'messageAdherenceTitle-' + i">
            {{ section.title }}
          </div>
          <div class="badge" [attr.data-testid]="'messageAdherenceScore-' + i">
            {{ section.numIncludedCorrectly }}/{{ section.totalNum }} {{'results.POINTS_LABEL' | transloco}}
          </div>
        </div>
        <div class="feedback-container">
          <div class="feedback-body">
            <p
              class="feedback-description"
              [attr.data-testid]="'messageAdherenceFeedback-' + i"
            ></p>
          </div>
        </div>
        <div>
          <qai-item-grid
            gap="24px"
            minItemWidth="280px"
            repeatCount="auto-fit"
            style="margin-bottom: 20px"
          >
            <qai-result-card
              *ngIf="section.positives.length > 0"
              [title]= "'results.TALKING_POINTS_COVERED' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-positives'"
            >
              <div class="points">
                <div class="points-list">
                  <div
                    class="point"
                    *ngFor="let point of section.positives"
                    [attr.data-testid]="'messageAdherence-' + i + '-positive'"
                  >
                    <img src="/assets/icons/check-2.svg" [alt]="'results.CHECKMARK_ICON_ALT' | transloco" />
                    {{ point.factText || point.messageText }}
                  </div>
                </div>
              </div>
            </qai-result-card>
            <qai-result-card
              *ngIf="
                section.positives.length == 0 && section.negatives.length > 0
              "
              [title]= "'results.TALKING_POINTS_COVERED' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-missed-points'"
            >
              <ul>
                <li>
                  {{'results.MISSED_ALL_KEY_POINTS' | transloco}}
                </li>
              </ul>
            </qai-result-card>
            <qai-result-card
              *ngIf="section.negatives.length > 0"
              [title]= "'results.TALKING_POINTS_MISSED' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-negatives'"
            >
              <div class="points">
                <div class="points-list">
                  <div
                    class="point"
                    *ngFor="let point of section.negatives"
                    [attr.data-testid]="'messageAdherence-' + i + '-negatives'"
                  >
                    <img src="/assets/icons/x-error.svg" [alt]="'results.X_ICON_ALT' | transloco" />
                    <div
                      [ngClass]="{ 'hide-talking-points': !showMissedFacts }"
                    >
                     {{ showMissedFacts ? (point.factText || point.messageText || '') : '' }}
                    </div>
                  </div>
                </div>
              </div>
            </qai-result-card>
            <qai-result-card
              *ngIf="
                section.positives.length > 0 && section.negatives.length == 0
              "
              [title]= "'results.TALKING_POINTS_MISSED' | transloco"
              [attr.data-testid]="'messageAdherence-' + i + '-perfect-score'"
            >
              <ul>
                <li>
                 {{'results.PERFECT_SCORE_MESSAGE' | transloco}}
                </li>
              </ul>
            </qai-result-card>
          </qai-item-grid>
        </div>
      </div>
    </ng-container>

    <div class="session-id">
      <div
        class="text"
        (click)="copyText()"
        [matMenuTriggerFor]="tooltipMenu"
        data-testId="sessionId"
      >
        {{'results.SESSION_ID' | transloco}} {{ practiceCallUuid }}
      </div>
    </div>
    <mat-menu
      #tooltipMenu="matMenu"
      yPosition="above"
      hasBackdrop="false"
      class="tooltip-copy-session-id"
    >
      <div>{{'results.SESSION_ID_COPIED' | transloco}}</div>
    </mat-menu>
  </div>
</qai-inner-wrap>
